var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 161.468,
    height: 165.387,
    viewBox: "0 0 161.468 165.387",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "teacher",
    transform: "translate(-103.116 -57.088)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65511",
    "data-name": "Path 65511",
    d: "M137.22,187.713c-3.867,2.375-7.563,5.01-11.278,7.635l-9.51-14.993c-2.348-3.706-7.019-11.332-1.732-14.537a9.26,9.26,0,0,1,2.84-.848c2.143-.482,4.465-1.464,6.438-.545a7.26,7.26,0,0,1,2.795,2.911,49.85,49.85,0,0,1,3.42,5.7c.795,1.732.295,2.429.616,4.161s1.947,3.483,2.893,4.974Z",
    transform: "translate(-0.981 -11.449)",
    fill: "#ffc9b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65512",
    "data-name": "Path 65512",
    d: "M125.829,196.131h-.17a.893.893,0,0,1-.58-.4l-6.912-10.885c-2.616-4.134-2.616-4.134-2.679-4.143-1.634-2.581-5.072-8.037-4.1-12.162a5.6,5.6,0,0,1,2.679-3.572,7.849,7.849,0,0,1,2.545-.893l.563-.116c.429-.089.893-.205,1.286-.321,1.786-.482,3.831-1.027,5.715-.161a7.939,7.939,0,0,1,3.179,3.241c.259.42.536.839.813,1.259a34.371,34.371,0,0,1,2.679,4.545,6.08,6.08,0,0,1,.571,2.866,7.144,7.144,0,0,0,.116,1.5,10.26,10.26,0,0,0,1.848,3.349,15.634,15.634,0,0,1,.893,1.313l3.518,5.554a.831.831,0,0,1,.116.679.893.893,0,0,1-.4.554c-3.634,2.232-7.2,4.751-10.644,7.144l-.58.411a.893.893,0,0,1-.455.241Zm-3.822-31.254a12.235,12.235,0,0,0-3.027.554q-.679.188-1.366.348l-.589.116a6.322,6.322,0,0,0-1.973.625,3.8,3.8,0,0,0-1.866,2.473c-.8,3.429,2.482,8.608,3.884,10.823l2.616,4.117,6.394,10.073c3.17-2.232,6.438-4.545,9.823-6.635l-3.036-4.8c-.241-.384-.545-.8-.848-1.232a11.189,11.189,0,0,1-2.161-4.054,9.673,9.673,0,0,1-.143-1.786,4.384,4.384,0,0,0-.411-2.134,33.932,33.932,0,0,0-2.536-4.3l-.83-1.277a6.456,6.456,0,0,0-2.411-2.581,3.491,3.491,0,0,0-1.518-.375Z",
    transform: "translate(-0.867 -11.339)",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65513",
    "data-name": "Path 65513",
    d: "M123.283,179.92a.893.893,0,0,1-.839-.589l-19.279-54.7a.894.894,0,0,1,1.688-.589l19.279,54.694a.893.893,0,0,1-.893,1.188Z",
    transform: "translate(0 -7.103)",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65514",
    "data-name": "Path 65514",
    d: "M124.6,169.32c-.893-.089-4.617-.991-5.5-.688a1.911,1.911,0,0,0-1.366,2.143c.223.75,1.036,1.152,1.786,1.429a24.4,24.4,0,0,0,5.849,1.4,6.519,6.519,0,0,0,1.482,7.09",
    transform: "translate(-1.562 -11.933)",
    fill: "#ffc9b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65515",
    "data-name": "Path 65515",
    d: "M126.744,181.483a.893.893,0,0,1-.616-.241,7.429,7.429,0,0,1-2.009-7.037,25.271,25.271,0,0,1-4.983-1.3,3.5,3.5,0,0,1-2.322-2.018,2.786,2.786,0,0,1,1.947-3.2c.786-.268,2.375,0,4.545.411.563.107,1.089.205,1.331.223a.893.893,0,0,1-.179,1.777,10.926,10.926,0,0,1-1.482-.25,19.028,19.028,0,0,0-3.643-.473c-.5.179-.893.688-.795,1.036s.955.75,1.232.893a23.449,23.449,0,0,0,5.635,1.339.9.9,0,0,1,.723,1.241,5.635,5.635,0,0,0,1.277,6.1.872.872,0,0,1-.661,1.5Z",
    transform: "translate(-1.461 -11.827)",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65516",
    "data-name": "Path 65516",
    d: "M178.22,161.77s-11.019-.054-15.037,7.947-12.993,30.361-12.993,30.361l-12.609-15.984L122.16,192.64s15.243,33.8,29.084,33.325c14.457-.509,25.449-30.057,25.449-30.057",
    transform: "translate(-2.038 -11.205)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65517",
    "data-name": "Path 65517",
    d: "M150.842,226.742c-14.171,0-28.968-32.459-29.6-33.852a.893.893,0,0,1,.384-1.143l15.466-8.555a.893.893,0,0,1,1.134.232l11.653,14.77c2.054-5.063,9.046-22.217,12.448-28.986,4.224-8.4,15.35-8.438,15.841-8.438a.893.893,0,1,1,0,1.786c-.161,0-10.528.071-14.243,7.456-3.956,7.876-12.868,30.057-12.957,30.28a.889.889,0,0,1-1.527.223L137.3,185.13,123.268,192.9c2.313,4.885,15.707,32.057,27.619,32.057h.268c13.7-.482,24.547-29.191,24.655-29.468a.891.891,0,1,1,1.67.625c-.455,1.223-11.376,30.111-26.262,30.637Z",
    transform: "translate(-1.932 -11.098)",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65518",
    "data-name": "Path 65518",
    d: "M248.168,223.123s.509,7.421,7.421,10.564,18.859-4.134,15.466-16.43-23.512-4.188-22.887,5.867Z",
    transform: "translate(-15.525 -16.48)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65519",
    "data-name": "Path 65519",
    d: "M259.044,235.2a9.6,9.6,0,0,1-3.938-.813c-7.313-3.322-7.912-10.983-7.938-11.314-.393-6.331,6.411-11.76,13.019-12.859,5.849-.982,10.2,1.509,11.608,6.661,1.616,5.867.08,11.341-4.224,15.011a13.394,13.394,0,0,1-8.528,3.313Zm-10.09-12.243a12.244,12.244,0,0,0,6.894,9.823c3.063,1.384,7.4.473,10.573-2.232,3.75-3.206,5.09-8.037,3.661-13.18-1.661-6.027-7.269-5.769-9.608-5.358C254.767,212.929,248.624,217.671,248.954,222.957Z",
    transform: "translate(-15.418 -16.368)",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65520",
    "data-name": "Path 65520",
    d: "M220.33,161.77s17.922,0,22.681,12.689c2.322,6.179,8.492,35.951,8.492,35.951l-19.859-2.188Z",
    transform: "translate(-12.547 -11.205)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65521",
    "data-name": "Path 65521",
    d: "M251.4,211.2h-.1l-19.824-2.188a.893.893,0,0,1-.768-.67l-11.35-46.434a.886.886,0,0,1,.866-1.107,36.371,36.371,0,0,1,9.823,1.625c6.912,2.161,11.608,6.188,13.7,11.608,2.313,6.179,8.278,34.825,8.528,36.093a.9.9,0,0,1-.875,1.072Zm-19.109-3.9,18,1.982c-1.179-5.626-6.2-29.271-8.206-34.611-3.8-10.144-16.743-11.787-20.69-12.055Z",
    transform: "translate(-12.439 -11.101)",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65522",
    "data-name": "Path 65522",
    d: "M184.908,161.7h30.414a11.35,11.35,0,0,1,11.314,11.35v59.73H173.55V173.05a11.35,11.35,0,0,1,11.358-11.35Z",
    transform: "translate(-7.539 -11.198)",
    fill: "#418fb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65523",
    "data-name": "Path 65523",
    d: "M226.529,233.566H173.443a.893.893,0,0,1-.893-.893v-59.73A12.26,12.26,0,0,1,184.8,160.7h30.414a12.26,12.26,0,0,1,12.207,12.242v59.73A.893.893,0,0,1,226.529,233.566ZM174.3,231.78h51.336V172.942a10.466,10.466,0,0,0-10.457-10.457H184.8a10.474,10.474,0,0,0-10.465,10.457Z",
    transform: "translate(-7.432 -11.091)",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65524",
    "data-name": "Path 65524",
    d: "M203.193,234.71a.893.893,0,0,1-.893-.893V172.283a.893.893,0,1,1,1.786,0v61.534A.893.893,0,0,1,203.193,234.71Z",
    transform: "translate(-10.617 -12.235)",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65525",
    "data-name": "Path 65525",
    d: "M202.224,201.178,193.25,161.7h17.94Z",
    transform: "translate(-9.648 -11.198)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65526",
    "data-name": "Path 65526",
    d: "M202.12,201.964a.893.893,0,0,1-.893-.7l-8.93-39.478a.892.892,0,0,1,.866-1.089H211.1a.9.9,0,0,1,.875,1.089l-8.93,39.478a.893.893,0,0,1-.929.7Zm-7.858-39.478,7.858,34.549,7.849-34.549Z",
    transform: "translate(-9.544 -11.09)",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65527",
    "data-name": "Path 65527",
    d: "M201.849,167.852l-10.939,9.189L189.74,161.7h12.109Z",
    transform: "translate(-9.272 -11.198)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65528",
    "data-name": "Path 65528",
    d: "M190.8,177.825a.9.9,0,0,1-.884-.83l-1.179-15.332a.891.891,0,0,1,.884-.982h12.117a.893.893,0,0,1,.893.893v6.152a.893.893,0,0,1-.321.688l-10.93,9.2a.893.893,0,0,1-.58.214Zm-.205-15.341.964,12.644,9.287-7.8v-4.849Z",
    transform: "translate(-9.165 -11.088)",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65529",
    "data-name": "Path 65529",
    d: "M203.3,167.852l10.93,9.189L215.4,161.7H203.3Z",
    transform: "translate(-10.724 -11.198)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65530",
    "data-name": "Path 65530",
    d: "M214.123,177.827a.893.893,0,0,1-.572-.214l-10.939-9.18a.893.893,0,0,1-.313-.688v-6.152a.893.893,0,0,1,.893-.893H215.3a.888.888,0,0,1,.884.964l-1.17,15.377a.893.893,0,0,1-.545.759A.974.974,0,0,1,214.123,177.827Zm-10.037-10.492,9.278,7.8.973-12.644H204.086Z",
    transform: "translate(-10.617 -11.091)",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65531",
    "data-name": "Path 65531",
    d: "M198,158h9.5v5.465a4.036,4.036,0,0,1-4.036,4.036h-1.438a4.036,4.036,0,0,1-4.036-4.036V158H198Z",
    transform: "translate(-10.155 -10.802)",
    fill: "#ffc9b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65532",
    "data-name": "Path 65532",
    d: "M203.338,168.242H201.9a4.92,4.92,0,0,1-4.92-4.92v-5.429a.893.893,0,0,1,.893-.893h9.5a.893.893,0,0,1,.893.893v5.465a4.929,4.929,0,0,1-4.929,4.885Zm-4.554-9.456v4.572a3.134,3.134,0,0,0,3.134,3.134h1.438a3.143,3.143,0,0,0,3.143-3.134v-4.572Z",
    transform: "translate(-10.047 -10.694)",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65533",
    "data-name": "Path 65533",
    d: "M165.213,120.786s-1.107-28.575-1.339-28.923c-2.223-3.572-5.6-7.733-3.956-11.608a9.822,9.822,0,0,1,4.465-4.759,8.707,8.707,0,0,1,3.393-.991c.75,0,2.375.509,2.92-.054s.116-1.884.161-2.491c.75-10.448,15.814-14.859,22.69-7.34,2.34-3.875,6.385-8.3,15.43-5.786,8.715,2.42,8.385,10.412,8.385,10.412s8.188-1.518,11.609.589a8.582,8.582,0,0,1,2.884,2.375c.321.509,1.107,5.742.295,5.554,2.081.491,4.286,1.161,5.608,2.849a5.813,5.813,0,0,1,.768,5.411c-.768,2.179-4.893,5.911-4.893,5.911-.205.589-2.473,24.512-3.849,30.655l-3.313-1.92c-2.465-.429-5.554.179-8.037.259l-18.413.571C190.761,121.795,175.232,124.572,165.213,120.786Z",
    transform: "translate(-6.033 -0.108)",
    fill: "#725858"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65534",
    "data-name": "Path 65534",
    d: "M178.942,123.544c-5.081,0-10.055-.482-14.153-2.036a.893.893,0,0,1-.58-.795c-.411-10.716-1.089-26.789-1.295-28.628-.277-.438-.563-.893-.893-1.331-2.2-3.366-4.679-7.144-3.072-10.948a10.76,10.76,0,0,1,4.858-5.2,9.3,9.3,0,0,1,3.742-1.089,4.893,4.893,0,0,1,1.161.089,5.455,5.455,0,0,0,1.161.1,5.076,5.076,0,0,0,0-1.036,6.092,6.092,0,0,1,0-.893c.357-4.956,3.875-9.18,9.171-11.019s10.671-.893,14.287,2.34c2.5-3.733,6.858-7.733,15.832-5.233a11.62,11.62,0,0,1,8.974,10.224c2.366-.33,8.287-.947,11.233.893l.134.08a8.93,8.93,0,0,1,3.027,2.581,15.386,15.386,0,0,1,.759,5.411,9.206,9.206,0,0,1,5.09,2.911,6.662,6.662,0,0,1,.893,6.251c-.732,2.1-3.965,5.206-4.911,6.081-.08.661-.339,2.982-.625,5.626-.822,7.653-2.206,20.467-3.179,24.762a.889.889,0,0,1-1.313.572l-3.17-1.831a22.218,22.218,0,0,0-5.081.1c-.893.08-1.786.17-2.679.188l-18.4.58c-2.223.071-4.849.286-7.635.518C188.112,123.16,183.487,123.544,178.942,123.544Zm-12.975-3.5c7.367,2.554,17.761,1.688,26.146.991,2.813-.232,5.465-.455,7.724-.527l18.413-.571c.777,0,1.625-.107,2.518-.188a22.324,22.324,0,0,1,5.715-.054A26.035,26.035,0,0,1,229,121.088c.893-5.054,2.152-16.368,2.911-23.36.563-5.242.643-5.938.732-6.188a1.009,1.009,0,0,1,.241-.366c1.107-1,4.081-3.938,4.643-5.545a4.947,4.947,0,0,0-.625-4.572c-1.17-1.491-3.25-2.09-5.108-2.527a.893.893,0,0,1-.67-1.072.947.947,0,0,1,.321-.509,16.967,16.967,0,0,0-.527-4.465,7.867,7.867,0,0,0-2.429-1.956l-.134-.08c-2.554-1.572-8.778-.893-10.966-.473a.891.891,0,0,1-1.054-.911c0-.295.17-7.322-7.733-9.519-8.474-2.348-12.162,1.643-14.421,5.358a.9.9,0,0,1-1.429.143c-3.054-3.34-8.224-4.393-13.162-2.679-4.617,1.6-7.671,5.224-7.983,9.465a4.136,4.136,0,0,0,.045.58A3.06,3.06,0,0,1,171.2,74.9c-.634.643-1.786.527-2.679.393a5.161,5.161,0,0,0-.786-.08,7.867,7.867,0,0,0-3.036.893,8.93,8.93,0,0,0-4.036,4.322c-1.232,2.893.893,6.135,2.92,9.26l.973,1.509c.116.348.321.643,1.411,28.852Z",
    transform: "translate(-5.921 0)",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_688",
    "data-name": "Ellipse 688",
    cx: 9.224,
    cy: 7.947,
    rx: 9.224,
    ry: 7.947,
    transform: "translate(156.206 114.543)",
    fill: "#ffc9b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65535",
    "data-name": "Path 65535",
    d: "M171.686,138.11c-5.581,0-10.126-3.965-10.126-8.84s4.545-8.849,10.126-8.849,10.117,3.974,10.117,8.849S177.267,138.11,171.686,138.11Zm0-15.9c-4.6,0-8.34,3.17-8.34,7.063s3.742,7.054,8.34,7.054,8.331-3.161,8.331-7.054S176.285,122.206,171.686,122.206Z",
    transform: "translate(-6.256 -6.779)",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_689",
    "data-name": "Ellipse 689",
    cx: 9.224,
    cy: 7.947,
    rx: 9.224,
    ry: 7.947,
    transform: "translate(210.007 114.543)",
    fill: "#ffc9b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65536",
    "data-name": "Path 65536",
    d: "M231.936,138.11c-5.581,0-10.126-3.965-10.126-8.84s4.545-8.849,10.126-8.849,10.117,3.974,10.117,8.849S237.517,138.11,231.936,138.11Zm0-15.9c-4.6,0-8.34,3.17-8.34,7.063s3.742,7.054,8.34,7.054,8.331-3.161,8.331-7.054S236.526,122.206,231.936,122.206Z",
    transform: "translate(-12.705 -6.779)",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65537",
    "data-name": "Path 65537",
    d: "M199.933,152.033A27.825,27.825,0,0,1,172.1,124.2V111.975c0-2.045-.58-5.09,0-7.054.429-1.375,1.732-1.875,2.679-2.893a9.76,9.76,0,0,0,2.563-5.188,8.626,8.626,0,0,0,7.929.223,17.306,17.306,0,0,0,6.251-5.242,11.609,11.609,0,0,0,8.93,2.679,19.163,19.163,0,0,0,8.84-3.509,16.015,16.015,0,0,0,7.269,8.8c3.241,1.643,8.7,1.839,11.1-1.4.6,8.5,0,17.252,0,25.78A27.825,27.825,0,0,1,199.933,152.033Z",
    transform: "translate(-7.356 -3.629)",
    fill: "#ffc9b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65538",
    "data-name": "Path 65538",
    d: "M199.825,152.827A28.753,28.753,0,0,1,171.1,124.1V111.876c0-.6-.054-1.313-.116-2.072a15,15,0,0,1,.188-5.242,4.956,4.956,0,0,1,1.965-2.438,8.393,8.393,0,0,0,.938-.813A8.84,8.84,0,0,0,176.4,96.6a.893.893,0,0,1,1.357-.616,7.733,7.733,0,0,0,7.09.17,16.18,16.18,0,0,0,5.938-4.992.893.893,0,0,1,1.295-.1,10.778,10.778,0,0,0,8.251,2.518,18.091,18.091,0,0,0,8.421-3.358.89.89,0,0,1,1.339.429,14.983,14.983,0,0,0,6.84,8.322c2.679,1.375,7.822,1.786,9.974-1.134a.891.891,0,0,1,1.607.464c.4,5.769.277,11.707.152,17.448-.062,2.759-.125,5.617-.125,8.394a28.753,28.753,0,0,1-28.718,28.682ZM177.912,98.044a10.778,10.778,0,0,1-2.536,4.465,10.288,10.288,0,0,1-1.143.991,3.384,3.384,0,0,0-1.357,1.563,13.966,13.966,0,0,0-.107,4.59c.054.795.116,1.545.116,2.215v12.225a26.938,26.938,0,1,0,53.877,0c0-2.795.058-5.661.121-8.438.107-5.063.223-10.278,0-15.359-2.929,2.063-7.51,1.848-10.716.214a16.332,16.332,0,0,1-7.278-8.26,19.243,19.243,0,0,1-8.34,3.054,12.609,12.609,0,0,1-8.93-2.331,17.172,17.172,0,0,1-6.027,4.8A9.885,9.885,0,0,1,177.912,98.044Z",
    transform: "translate(-7.249 -3.53)",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65539",
    "data-name": "Path 65539",
    d: "M202.8,132.688a19.147,19.147,0,0,1-2.786-.223.893.893,0,1,1,.313-1.759,13.627,13.627,0,0,0,4.242,0c.179-.822-.893-3.893-2.411-6.769a.893.893,0,1,1,1.581-.822c1.009,1.92,3.25,6.581,2.429,8.412a1.536,1.536,0,0,1-1.036.893,9.652,9.652,0,0,1-2.331.268Z",
    transform: "translate(-10.293 -7.01)",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65540",
    "data-name": "Path 65540",
    d: "M194.5,109.572H180.856a1.786,1.786,0,0,1,0-3.572H194.5a1.786,1.786,0,1,1,0,3.572Z",
    transform: "translate(-8.13 -5.235)",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65541",
    "data-name": "Path 65541",
    d: "M222.709,109.572H209.056a1.786,1.786,0,1,1,0-3.572H222.7a1.786,1.786,0,1,1,0,3.572Z",
    transform: "translate(-11.149 -5.235)",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65542",
    "data-name": "Path 65542",
    d: "M179.425,115.43H195.5a2.286,2.286,0,0,1,2.286,2.286v1.491a7.706,7.706,0,0,1-7.706,7.706h-5.242a7.706,7.706,0,0,1-7.706-7.706v-1.482a2.286,2.286,0,0,1,2.295-2.295Z",
    transform: "translate(-7.922 -6.245)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65543",
    "data-name": "Path 65543",
    d: "M189.981,127.709h-5.233a8.617,8.617,0,0,1-8.608-8.608v-1.482a3.188,3.188,0,0,1,3.179-3.179h16.073a3.179,3.179,0,0,1,3.17,3.179v1.491a8.608,8.608,0,0,1-8.581,8.6Zm-10.662-11.492a1.393,1.393,0,0,0-1.393,1.393V119.1a6.831,6.831,0,0,0,6.822,6.822h5.233a6.822,6.822,0,0,0,6.813-6.822v-1.482a1.384,1.384,0,0,0-1.384-1.393Z",
    transform: "translate(-7.816 -6.139)",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65544",
    "data-name": "Path 65544",
    d: "M208.485,115.43h16.073a2.286,2.286,0,0,1,2.286,2.286v1.491a7.706,7.706,0,0,1-7.706,7.706H213.9a7.706,7.706,0,0,1-7.706-7.706v-1.482a2.286,2.286,0,0,1,2.295-2.295Z",
    transform: "translate(-11.033 -6.245)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_38303",
    "data-name": "Group 38303",
    transform: "translate(163.144 108.301)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65545",
    "data-name": "Path 65545",
    d: "M219.041,127.709H213.8a8.608,8.608,0,0,1-8.6-8.608v-1.482a3.188,3.188,0,0,1,3.179-3.179h16.073a3.179,3.179,0,0,1,3.179,3.179v1.491A8.608,8.608,0,0,1,219.041,127.709Zm-10.662-11.492a1.393,1.393,0,0,0-1.393,1.4v1.491a6.822,6.822,0,0,0,6.813,6.822h5.242a6.822,6.822,0,0,0,6.813-6.822v-1.491a1.393,1.393,0,0,0-1.393-1.393Z",
    transform: "translate(-174.071 -114.44)",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65546",
    "data-name": "Path 65546",
    d: "M176.412,120.446h-5.179a.893.893,0,0,1,0-1.786h5.179a.893.893,0,0,1,0,1.786Z",
    transform: "translate(-170.34 -114.892)",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65547",
    "data-name": "Path 65547",
    d: "M234.7,120.446h-5.188a.893.893,0,0,1,0-1.786H234.7a.893.893,0,0,1,0,1.786Z",
    transform: "translate(-176.578 -114.892)",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65548",
    "data-name": "Path 65548",
    d: "M205.458,120.446h-5.3a.893.893,0,0,1,0-1.786h5.3a.893.893,0,0,1,0,1.786Z",
    transform: "translate(-173.437 -114.892)",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65549",
    "data-name": "Path 65549",
    d: "M201.454,143.137a25.779,25.779,0,0,1-9.322-1.706.895.895,0,0,1,.643-1.67,25.9,25.9,0,0,0,17.645,0,.895.895,0,1,1,.688,1.652A27.155,27.155,0,0,1,201.454,143.137Z",
    transform: "translate(-172.611 -117.143)",
    fill: "#093f68"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_65550",
    "data-name": "Path 65550",
    d: "M236.913,223.4l-29.093-2.857V180.82l23.315,1.786c3.34.634,5.777,3.875,5.777,7.662Z",
    transform: "translate(-11.207 -13.244)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65551",
    "data-name": "Path 65551",
    d: "M236.806,224.182h-.089l-29.093-2.849a.893.893,0,0,1-.8-.893V180.713a.888.888,0,0,1,.964-.893l23.315,1.786h.1c3.768.714,6.5,4.3,6.5,8.537v33.147a.9.9,0,0,1-.893.893Zm-28.2-4.554,27.307,2.679V190.16a6.673,6.673,0,0,0-5-6.778L208.588,181.7Z",
    transform: "translate(-11.1 -13.137)",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65552",
    "data-name": "Path 65552",
    d: "M269.513,220.535l-29.093,2.857V190.228c0-3.786,2.438-7.028,5.777-7.662l23.315-1.786Z",
    transform: "translate(-14.697 -13.24)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65553",
    "data-name": "Path 65553",
    d: "M240.293,224.18a.9.9,0,0,1-.893-.893V190.122c0-4.233,2.732-7.822,6.5-8.537h.1l23.324-1.786a.887.887,0,0,1,.956.893v39.737a.893.893,0,0,1-.8.893l-29.093,2.849Zm5.894-40.835a6.673,6.673,0,0,0-5,6.778v32.147l27.307-2.679V181.666Z",
    transform: "translate(-14.588 -13.135)",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65554",
    "data-name": "Path 65554",
    d: "M231.735,228.546l-27.825-2.857V185.97l27.825,2.849Z",
    transform: "translate(-10.789 -13.795)",
    fill: "#ea7a6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65555",
    "data-name": "Path 65555",
    d: "M231.631,229.335h-.063l-27.825-2.849a.893.893,0,0,1-.8-.893v-39.7a.9.9,0,0,1,.947-.893l27.825,2.849a.893.893,0,0,1,.8.893v39.728a.85.85,0,0,1-.884.866ZM204.7,224.781l26.039,2.679V189.518L204.7,186.839Z",
    transform: "translate(-10.685 -13.691)",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65556",
    "data-name": "Path 65556",
    d: "M273.555,225.689l-27.825,2.857V188.819l27.825-2.849Z",
    transform: "translate(-15.265 -13.795)",
    fill: "#ea7a6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65557",
    "data-name": "Path 65557",
    d: "M245.623,229.335a.9.9,0,0,1-.893-.893V188.714a.893.893,0,0,1,.8-.893L273.358,185a.889.889,0,0,1,.982.884v39.728a.893.893,0,0,1-.8.893l-27.825,2.849Zm.893-39.817v37.933l26.039-2.679V186.848Z",
    transform: "translate(-15.158 -13.691)",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65558",
    "data-name": "Path 65558",
    d: "M0,0H9.519V39.728H0Z",
    transform: "translate(230.465 214.742) rotate(180)",
    fill: "#ea7a6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65559",
    "data-name": "Path 65559",
    d: "M244.482,229.674h-9.519a.893.893,0,0,1-.893-.893V189.053a.893.893,0,0,1,.893-.893h9.519a.893.893,0,0,1,.893.893v39.728A.893.893,0,0,1,244.482,229.674Zm-8.626-1.786h7.733V189.946h-7.733Z",
    transform: "translate(-14.017 -14.03)",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65560",
    "data-name": "Path 65560",
    d: "M277.169,211.538a1.875,1.875,0,0,0-1.447-.509c-1.634.295-1.179,4.063-2.858,4.947-1.286.67-4.465.107-5.974.223a4.322,4.322,0,0,0-2.456.714,4.25,4.25,0,0,0-1.152,1.92,37.926,37.926,0,0,0-1.884,7.429c-.67,4.465,2.59,4.465,6.1,4.893a12.412,12.412,0,0,0,10.555-4.349,12.064,12.064,0,0,0,2.215-10.189,12.7,12.7,0,0,0-3.1-5.081Z",
    transform: "translate(-16.933 -16.477)",
    fill: "#ffc9b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65561",
    "data-name": "Path 65561",
    d: "M268.521,232.005a11.29,11.29,0,0,1-1.232-.063l-.661-.071c-2.241-.241-4.358-.473-5.527-1.982a4.92,4.92,0,0,1-.7-3.867,39.288,39.288,0,0,1,1.929-7.608,4.134,4.134,0,0,1,4.384-3.215,17.137,17.137,0,0,1,2.09.045,9.924,9.924,0,0,0,3.572-.17c.473-.25.741-1.223.973-2.072.348-1.268.75-2.679,2.134-2.956a2.679,2.679,0,0,1,2.17.688,13.515,13.515,0,0,1,3.4,5.536,13.082,13.082,0,0,1-2.384,10.992,13.493,13.493,0,0,1-10.153,4.742Zm-1.259-15.037h-.411a2.456,2.456,0,0,0-2.84,2.045,37.058,37.058,0,0,0-1.84,7.251,3.242,3.242,0,0,0,.348,2.509c.7.893,2.447,1.1,4.3,1.3l.661.071a11.51,11.51,0,0,0,9.76-4.027,11.135,11.135,0,0,0,2.054-9.385,11.831,11.831,0,0,0-2.8-4.626,1.107,1.107,0,0,0-.732-.33c-.277.054-.554,1.072-.723,1.679-.33,1.206-.705,2.563-1.866,3.179s-2.795.464-4.465.375c-.527-.018-1.036-.045-1.447-.045Z",
    transform: "translate(-16.822 -16.37)",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65562",
    "data-name": "Path 65562",
    d: "M252.893,204.518a.9.9,0,0,1-.893-.893v-6.206a.893.893,0,0,1,.813-.893L268.636,195a.9.9,0,0,1,.982.893v6.251a.893.893,0,0,1-.813.893l-15.841,1.509Zm.893-6.251v4.411l14.055-1.339v-4.411Z",
    transform: "translate(-15.936 -14.761)",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65563",
    "data-name": "Path 65563",
    d: "M180.962,228.245a.9.9,0,0,1-.482-1.652l13.644-8.68a.9.9,0,0,1,.964,1.509l-13.653,8.68A.839.839,0,0,1,180.962,228.245Z",
    transform: "translate(-8.237 -17.2)",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65564",
    "data-name": "Path 65564",
    d: "M181.723,123.321a.893.893,0,0,1-.572-1.581l5.358-4.465a.894.894,0,1,1,1.143,1.375l-5.358,4.465a.893.893,0,0,1-.571.205Z",
    transform: "translate(-8.318 -6.42)",
    fill: "#dfeaef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65565",
    "data-name": "Path 65565",
    d: "M191.6,123.265a.889.889,0,0,1-.589-1.563l2.759-2.411a.893.893,0,1,1,1.17,1.348l-2.759,2.4a.893.893,0,0,1-.58.223Z",
    transform: "translate(-9.376 -6.633)",
    fill: "#dfeaef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65566",
    "data-name": "Path 65566",
    d: "M212.523,122.469a.893.893,0,0,1-.58-1.572l4.59-3.9a.894.894,0,1,1,1.152,1.366l-4.581,3.893A.893.893,0,0,1,212.523,122.469Z",
    transform: "translate(-11.615 -6.39)",
    fill: "#dfeaef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65567",
    "data-name": "Path 65567",
    d: "M219.764,124.709a.9.9,0,0,1-.536-1.607l4.465-3.34a.893.893,0,1,1,1.072,1.42l-4.465,3.349a.947.947,0,0,1-.536.179Z",
    transform: "translate(-12.391 -6.684)",
    fill: "#dfeaef"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuest);
export default __webpack_public_path__ + "static/media/guest.c3f5971ff0a04c236386c6eb90fcc3d3.svg";
export { ForwardRef as ReactComponent };